import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { WindowRef } from '../utils/window';

import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {DTFService} from '../dtf.service';
import { TranslateUtil } from '../utils/translate-util';
import { DTFHomepageService } from '../components/dtfhomepage/dtfhomepage.service';
import { APP_CONSTANTS } from '../utils/app-constants';
import { SharedTranslateModule } from '../utils/sharedTranslateModule';


@Component({
    selector: 'mbfs-footer-nav',
    templateUrl: './footer.component.html',
    imports: [SharedTranslateModule],
    providers: [WindowRef]
})


export class FooterComponent implements OnInit {

    //Scroll to Top
    isShow: boolean;
    topPosToStartShowing = 75;
  
    @HostListener('window:scroll')
    checkScroll() {
        
      // window의 scroll top
      // Both window.pageYOffset and document.documentElement.scrollTop returns the same result in all the cases. window.pageYOffset is not supported below IE 9.
  
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;     
      this.isShow = true;
      if (scrollPosition >= this.topPosToStartShowing) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    }
      // TODO: Cross browsing
  gotoTop() {
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }


    public registration: any;
    public classicSiteURL: any;
    public innerWidth: any;
    public contextPath: any;
    router: Router;
    _window: WindowRef;
    currentYear: Number;
    currentCountry: string;
    isCanadaPortal = false;
    isFuso = true;
    language = '';
    targetRedirect = '';
    localRedirect = '';
    usUrl: string;
    caUrl: string;
    defaultHeader='';
    displayDefault=false;
    guestPay = false;
    repayURL = 'https://dtf.repay.io/ebpp/';

    constructor(router: Router, window: WindowRef,public translate: TranslateService, private dtfservice: DTFService,
                public translateUtil: TranslateUtil, public dtfhomepageService: DTFHomepageService
                ) {
        this.router = router;
        this._window = window;
        this.repayURL = (this._window.nativeWindow as any).mbfs.repayURL;
    }
    ngOnInit() {
        // this.registration = (window as any).mbfs.footer.registration || false;
        // this.classicSiteURL = (window as any).mbfs.classicSiteURL;
        this.defaultHeader = (this._window.nativeWindow as any).mbfs.defaultHeader;
        if(this.defaultHeader === "none"){
          this.displayDefault = true;
        }
        // if (this.defaultHeader === "guestpay") {
        //     this.guestPay = true;  
        // }
        this.innerWidth = (window as any).innerWidth;
        this.contextPath = (this._window.nativeWindow as any).mbfs.contextPath;
        this.currentYear = new Date().getFullYear();
        this.langInit();
        this.translateUtil.getCurrentCountry().subscribe(val => {
          this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
        });
    }

    langInit() {
      // Initializes Language and all URL's for href
      this.language = (this._window.nativeWindow as any).mbfs.language;
      this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
      this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;

      // Checks if what language user is to redirect to correct href in link nav
      if (this.language === 'en-CA') {
          this.localRedirect = this.usUrl + '/ca/en/';
      } else if (this.language === 'fr-CA') {
          this.localRedirect = this.usUrl + '/ca/fr/';
      } else {
          this.localRedirect = this.usUrl;
      }
    }



    @HostListener('window:resize', ['$event'])
    onResize(event: Event) {
        this.innerWidth = (window as any).innerWidth;
    }

    onClickLinkHeader(e: Event): void {
        let headerLink = (<any>e).currentTarget;
        let list = headerLink.parentNode.parentNode;
        this.toggleLinkHeaderOpenClass(list);
        // list.isOpen = !list.isOpen;
    }

    onClickOtherSitesLinkHeader(e: Event): void {
        let headerLink = (<any>e).currentTarget.parentNode;
        let listsParent = document.getElementById('mbfs-footer-nav-other-sites-links');

        if (listsParent) {
            this.toggleLinkHeaderOpenClass(headerLink);
            this.toggleLinkHeaderOpenClass(listsParent);
        }
    }


    toggleLinkHeaderOpenClass(list: Element): void {
        let openClass = 'open';
        let listClasses = list.className.split(' ');
        let openClassIndex = -1;

        // Check if open class is already applied
        for (let i = 0; i < listClasses.length; i++) {
            if (listClasses[i] === openClass) {
                openClassIndex = i;
                break;
            }
        }

        if (openClassIndex !== -1) {
            // If already applied, remove open class
            let newListClass = '';
            for (let j = 0; j < listClasses.length; j++) {
                if (j !== openClassIndex) {
                    newListClass += listClasses[j];
                }
            }

            list.className = newListClass;
            if (this.innerWidth < 768) {
                list.setAttribute('aria-expanded', 'false');
            }
        } else {
            // If not applied, add open class
            list.className = list.className.trim() + ' ' + openClass;
            if (this.innerWidth < 768) {
                list.setAttribute('aria-expanded', 'true');
            }
        }
    }

    onDashboard(e: Event) {
        e.preventDefault();
        this.router.navigate(['dashboard']);
        (this._window.nativeWindow as any).scroll(0, 0);
    }

    onSchedulePayment(e: Event) {
        e.preventDefault();
        this.router.navigate(['make-payment']);
        (this._window.nativeWindow as any).scroll(0, 0);
    }

    onTransactionHistory(e: Event) {
        e.preventDefault();
        this.router.navigate(['statements']);
        (this._window.nativeWindow as any).scroll(0, 0);
    }



    openNewWindow(e: Event, url: String) {
        e.preventDefault();
        this._window.nativeWindow.open(url);
        e.stopPropagation();
    }
}
